import {NgModule} from '@angular/core';
import {Routes, RouterModule} from '@angular/router';

// COMPONENTS
import {HomeComponent} from './pages/home/home.component';
import {ForgotPasswordFormComponent} from './pages/forgot-password-form/forgot-password-form.component';
import {NewPasswordFormComponent} from './pages/new-password-form/new-password-form.component';
import {SecurityCodeFormComponent} from './pages/security-code-form/security-code-form.component';
import {ContractsComponent} from './pages/contracts/contracts.component';
import {PersonalDataComponent} from './pages/personal-data/personal-data.component';
import {ContractDetailsComponent} from './components/contract-details/contract-details.component';
import {ActivateAccessComponent} from './pages/activate-access/activate-access.component';
import {AccessValidationMessageComponent} from './pages/access-validation-message/access-validation-message.component';
import {AccessSecurityCodeComponent} from './pages/access-security-code/access-security-code.component';
import {PaymentErrorComponent} from './pages/payment-error/payment-error.component';
import {PaymentSuccessComponent} from './pages/payment-success/payment-success.component';
import {EnterMailPassComponent} from './pages/enter-mail-pass/enter-mail-pass.component';
import {ContractSummaryComponent} from './pages/contract-summary/contract-summary.component';
import {ChangeFirstPasswordComponent} from './pages/change-first-password/change-first-password.component';

// GUARDS
import {AdminGuard} from './services/admin.guard';
const routes: Routes = [
    {path: '', component: HomeComponent},
    {path: 'contrasena-olvidada', component: ForgotPasswordFormComponent},
    {path: 'nueva-contrasena', component: NewPasswordFormComponent},
    {path: 'cambiar-primera-contrasena', component: ChangeFirstPasswordComponent},
    {path: 'codigo-seguridad', component: SecurityCodeFormComponent},
    {path: 'contratos', component: ContractsComponent, canActivate: [AdminGuard]},
    {path: 'contratos/:idContract', component: ContractDetailsComponent, canActivate: [AdminGuard]},
    {path: 'datos', component: PersonalDataComponent, canActivate: [AdminGuard]},
    {path: 'activar-acceso', component: ActivateAccessComponent},
    {path: 'mensaje-validacion-acceso', component: AccessValidationMessageComponent},
    {path: 'acceso-codigo-seguridad', component: AccessSecurityCodeComponent},
    {path: 'introducir-codigo-seguridad', component: AccessSecurityCodeComponent},
    {path: 'seleccionar-mail-pass', component: EnterMailPassComponent},
    {path: 'error-de-pago', component: PaymentErrorComponent},
    {path: 'pago-exitoso', component: PaymentSuccessComponent},
    {path: 'resumen-de-renovacion', component: ContractSummaryComponent, canActivate: [AdminGuard]},
    // Default redirection route:
    {path: '**', redirectTo: '', pathMatch: 'full'}
];

@NgModule({
    imports: [RouterModule.forRoot(routes, {
        initialNavigation: 'enabled',
        scrollPositionRestoration: 'top'
    })],
    exports: [RouterModule]
})
export class AppRoutingModule {
}
